import styles from './SectionContainer.module.scss'

interface SectionContainerProps {
  children: React.ReactNode
  className?: string
  clipX?: boolean
  maxWidth?: number
}

export const SectionContainer = ({
  children,
  className,
  clipX,
  maxWidth = 960,
}: SectionContainerProps) => (
  <div
    className={`${styles.container} mx-auto w-full${clipX ? ' overflow-x-hidden' : ''}${className ? ` ${className}` : ''}`}
    style={{ maxWidth }}
  >
    {children}
  </div>
)
